import React from "react";
import Meta from "../../components/Meta";
import MemberViewSection from "../../components/Custom/MemberViewSection";
import SideNav from "../../components/Custom/SideNav";
import StateFarmCheckModal from "../../components/Custom/StateFarmCheckModal";
import { requireAuth } from "../../util/auth";


function MemberViewPage(props) {
  return (
    <>
      <Meta title="Private" />
      <MemberViewSection/>
      <SideNav current = "tools"/>
      <StateFarmCheckModal onDone={() => null}/>
    </>
  );
}

export default requireAuth(MemberViewPage);
